import { store } from "quasar/wrappers";
import { createStore } from "vuex";
import { api } from "src/boot/axios";

// import example from './module-example'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(function (/* { ssrContext } */) {
  const Store = createStore({
    modules: {
      // example
    },
    state: {
      alive: true,
      authToken: null,
      user: {},
      business: {},
      messages: [],
      notifications: [],
      messageCount: 0,
      monitors: {
        messages: false,
        notifications: false,
      },
      taskTimer: {
        hasStarted: false,
        task: undefined,
        timeBegan: null,
        timeStopped: null,
        stoppedDuration: 0,
        started: null,
        running: false,
        time: "00:00:00",
      },
    },
    actions: {
      //- Fetch
      fetchNotifications({ commit }) {
        api({
          method: "get",
          url: "/manual/v1/notification",
          headers: {
            authtoken: this.state.authToken,
          },
        })
          .then((res) => {
            commit("setAlive", true);
            commit("setNotifications", res.data);
            api({
              method: "get",
              url: "/manual/v1/chat/count",
              headers: {
                authtoken: this.state.authToken,
              },
            })
              .then((res) => {
                commit("setMessageCount", res.data.count);
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
            commit("setAlive", false);
          });
      },
      fetchMessages({ commit }) {
        //- DEPRECATED
        api({
          method: "get",
          url: "/manual/v1/chat",
          headers: {
            authtoken: this.state.authToken,
          },
        })
          .then((res) => {
            commit("setMessages", res.data);
            api({
              method: "get",
              url: "/manual/v1/notification",
              headers: {
                authtoken: this.state.authToken,
              },
            })
              .then((res) => {
                // console.log("notifications", res.data);
                commit("setAlive", true);
                commit("setNotifications", res.data);
              })
              .catch((err) => {
                console.error(err);
                commit("setAlive", false);
              });
          })
          .catch((err) => {
            console.error(err);
            commit("setAlive", false);
          });
      },
    },
    mutations: {
      //- Auth
      setAuthToken(state, val) {
        state.authToken = val;
      },
      setUser(state, val) {
        state.user = val;
      },
      setBusiness(state, val) {
        state.business = val;
      },
      //- Operations
      setAlive(state, val) {
        state.alive = val;
      },
      setMessages(state, val) {
        state.messages = val;
      },
      setNotifications(state, val) {
        state.notifications = val;
      },
      setMessageCount(state, val) {
        state.messageCount = val;
      },
      setMessageMonitor(state) {
        this.dispatch("fetchMessages");
        state.monitors.messages = setInterval(() => {
          this.dispatch("fetchMessages");
        }, 10000);
      },
      stopMessageMonitor(state) {
        console.log("Message monitor stopped");
        clearInterval(state.monitors.messages);
        state.monitors.messages = false;
      },
      setNotificationMonitor(state) {
        this.dispatch("fetchNotifications");
        state.monitors.notifications = setInterval(() => {
          this.dispatch("fetchNotifications");
        }, 5000);
      },
      stopNotificationMonitor(state) {
        clearInterval(state.monitors.notifications);
        state.monitors.notifications = false;
      },
      setTimer(state, val) {
        // console.log("set timer", val);
        state.taskTimer.task = val;
        this.commit("startTimer");
      },
      startTimer(state) {
        state.taskTimer.hasStarted = true;
        if (state.taskTimer.running) {
          return;
        }
        if (state.taskTimer.timeBegan === null) {
          this.commit("resetTimer");
          state.taskTimer.timeBegan = new Date();
        }
        if (state.taskTimer.timeStopped !== null) {
          state.taskTimer.stoppedDuration +=
            new Date() - state.taskTimer.timeStopped;
        }
        // Interval
        state.taskTimer.started = setInterval(() => {
          this.commit("clockRunning");
        }, 1000);
        state.taskTimer.running = true;
      },
      pauseTimer(state) {
        state.taskTimer.running = false;
        state.taskTimer.timeStopped = new Date();
        clearInterval(state.taskTimer.started);
      },
      stopTimer(state) {
        clearInterval(state.taskTimer.started);
        state.taskTimer = {
          hasStarted: false,
          task: undefined,
          timeBegan: null,
          timeStopped: null,
          stoppedDuration: 0,
          started: null,
          running: false,
          time: "00:00:00",
        };
      },
      resetTimer(state) {
        state.taskTimer.running = false;
        clearInterval(state.taskTimer.started);
        state.taskTimer.stoppedDuration = 0;
        state.taskTimer.timeBegan = null;
        state.taskTimer.timeStopped = null;
        state.taskTimer.time = "00:00:00";
      },
      clockRunning(state) {
        console.log("Clock running");
        var currentTime = new Date();
        var timeElapsed = new Date(
          currentTime -
            state.taskTimer.timeBegan -
            state.taskTimer.stoppedDuration
        );
        var hour = timeElapsed.getUTCHours();
        var min = timeElapsed.getUTCMinutes();
        var sec = timeElapsed.getUTCSeconds();
        const zeroPrefix = function (num, digit) {
          var zero = "";
          for (var i = 0; i < digit; i++) {
            zero += "0";
          }
          return (zero + num).slice(-digit);
        };
        state.taskTimer.time =
          zeroPrefix(hour, 2) +
          ":" +
          zeroPrefix(min, 2) +
          ":" +
          zeroPrefix(sec, 2);
      },
      logout(state) {
        // clearInterval(state.monitors.messages);
        this.commit("stopMessageMonitor");
        state.user = {};
        state.business = {};
        state.messages = [];
        state.notifications = [];
        state.authToken = null;
      },
    },

    // enable strict mode (adds overhead!)
    // for dev mode and --debug builds only
    strict: process.env.DEBUGGING,
  });

  return Store;
});
